/* eslint-disable no-useless-escape */
import dayjs from 'dayjs'

export function isEmail(value) {
  const expression =
    // eslint-disable-next-line no-control-regex
    // eslint-disable-next-line no-useless-escape
    // eslint-disable-next-line no-control-regex
    // eslint-disable-next-line no-control-regex
    /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i
  return expression.test(String(value))
}

export function isNumber(value) {
  if (isNaN(parseInt(value))) {
    return false
  } else {
    return typeof parseInt(value) === 'number'
  }
}

export function formatCurrency(value, minDigit = 0, maxDigit = 0) {
  const formatted = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: minDigit,
    maximumFractionDigits: maxDigit,
  }).format(value)

  return formatted.replace(/Rp\s?/g, '')
}

export function formatPercentage(value, minDigit = 0, maxDigit = 2) {
  return new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: minDigit,
    maximumFractionDigits: maxDigit,
  }).format(value)
}

export function formatNumber(value) {
  return new Intl.NumberFormat('id-ID').format(value)
}

export function isObject(value, field) {
  if (Object.prototype.hasOwnProperty.call(value, field)) {
    return true
  }

  return false
}

export function formatDate(value, time = false) {
  let result = '-'

  if (value) {
    const currentTime = new Date(value)
    result = time
      ? dayjs(currentTime).format('DD/MM/YYYY HH:mm:ss')
      : dayjs(currentTime).format('DD/MM/YYYY')
  }

  return result
}

export function roundNumber(value) {
  if (value % 1 >= 0.5) {
    return Math.ceil(value)
  } else {
    return Math.floor(value)
  }
}

export function floor(value) {
  return Math.floor(value)
}

export function ceiling(number, significance = 100) {
  return Math.ceil(number / significance) * significance
}

export function round(number, numToFix = 0) {
  var num = Number(number) // The Number() only visualizes the type and is not needed
  var roundedString = num.toFixed(numToFix)
  var rounded = Number(roundedString) // toFixed() returns a string (often suitable for printing already)
  return rounded
}

export function focusNext(vm, refName) {
  vm.$nextTick(() => {
    const ref = vm.$refs[refName]

    if (!ref) return

    // PrimeVue button
    if (ref.$el?.tagName === 'BUTTON') {
      ref.$el.focus()
      return
    }

    // AutoComplete PrimeVue
    if (ref.$el) {
      const autocompleteInput = ref.$el.querySelector('.p-autocomplete-input')

      if (autocompleteInput) {
        autocompleteInput.focus()
        autocompleteInput.select?.()
        return
      }
    }

    // PrimeVue component
    if (ref.$el) {
      const input = ref.$el.querySelector('input')

      if (input) {
        input.focus()
        input.select?.()
        return
      }

      const button = ref.$el.querySelector('button')

      if (button) {
        button.focus()
        return
      }
    }

    // native element
    ref.focus?.()
  })
}

export function handleKeydown(vm, event, nextRef, prevRef = null) {
  if (event.key === 'Enter') {
    event.preventDefault()
    focusNext(vm, nextRef)
  }

  if (event.key === 'Tab') {
    event.preventDefault()

    if (event.shiftKey && prevRef) {
      focusNext(vm, prevRef)
    } else {
      focusNext(vm, nextRef)
    }
  }
}

export function focusNextField(vm, refName, selectAll = false) {
  vm.$nextTick(() => {
    const ref = vm.$refs[refName]

    if (!ref) {
      console.warn(`Ref "${refName}" tidak ditemukan`)
      return
    }

    const el = ref.$el || ref

    const focusElement = (element) => {
      element.focus()

      if (selectAll && typeof element.select === 'function') {
        element.select()
      }
    }

    // Native input / textarea / button
    if (
      el.tagName === 'INPUT' ||
      el.tagName === 'TEXTAREA' ||
      el.tagName === 'BUTTON'
    ) {
      focusElement(el)
      return
    }

    // Cari input / textarea di dalam PrimeVue component
    const input = el.querySelector?.('input, textarea')

    if (input) {
      focusElement(input)
      return
    }

    // Cari button
    const button = el.querySelector?.('button')

    if (button) {
      focusElement(button)
    }
  })
}

export function handleKeydownField(vm, event, nextRef, selectAll = false) {
  if (event.key !== 'Enter') return

  event.preventDefault()
  event.stopPropagation()

  focusNextField(vm, nextRef, selectAll)
}
